export const BUCKET_COLORS = {
  "0-30": "#10B981",
  "31-60": "#3B82F6",
  "61-90": "#F59E0B",
  "91-180": "#F97316",
  "180+": "#EF4444",
};

export const SYMBOLS = { INR: "₹", USD: "$", EUR: "€", GBP: "£" };

export function fmtCur(byCurrency) {
  const entries = Object.entries(byCurrency || {}).filter(([, v]) => v);
  if (!entries.length) return "—";
  return entries
    .map(([c, v]) => `${SYMBOLS[c] || c + " "}${Number(v).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`)
    .join("  +  ");
}

export function bucketBadgeClass(bucket) {
  const map = {
    "0-30": "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20",
    "31-60": "bg-blue-500/10 text-blue-600 dark:text-blue-400 border-blue-500/20",
    "61-90": "bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/20",
    "91-180": "bg-orange-500/10 text-orange-600 dark:text-orange-400 border-orange-500/20",
    "180+": "bg-rose-500/10 text-rose-600 dark:text-rose-400 border-rose-500/20",
  };
  return map[bucket] || "";
}
